export default __webpack_public_path__ + "static/media/customer.9e4dc287.svg";